import firebase from '@/firebase'
import { FS_COLLECTIONS } from '@/firebase'
const db = firebase.firestore()
const storage = firebase.storage().ref()
var cargadorIndicePacientes = null
var cargadorIndicePacientesV2 = null;
var cargadorCatalogosPacientes = null


const store = {
  state: {
    indicePacientes: [],
    paciente: {},
    catalogos: { Colores: [] },
    planesBienestar: {},
  },
  getters: {
    indicePacientes: state => {
      return state.indicePacientes
    },
    pacienteActual: state => {
      return state.paciente
    },
    catalogoColores: state => {
      return state.catalogos.Colores
    },
    planesBienestar: state => {
      return state.planesBienestar;
    }
  },
  mutations: {
    ASIGNA_PACIENTE(state, paciente) {
      state.paciente = paciente
    },
    ASIGNA_INDICE_PACIENTES(state, indicePacientes) {
      state.indicePacientes = indicePacientes
    },
    ASIGNA_INDICE_PACIENTES_V2(state, indicePacientes) {
      state.indicePacientes = indicePacientes
    },
    ASIGNA_CATALOGOS(state, catalogos) {
      state.catalogos = catalogos
    },
    ASIGNA_PLANES_BIENESTAR(state, planes) {
      state.planesBienestar = planes;
    }
  },
  actions: {
    cargaIndicePacientes({ commit, getters }, recarga = false) {

      if (getters.indicePacientes === null) {
        //console.log("🚀 ~ file: pacientes.js ~ line 52", true)
        if (typeof cargadorIndicePacientes === 'function') {
          cargadorIndicePacientes()
        }
        cargadorIndicePacientes = null
        //console.log('getters.indicePacientes === null')
      }

      if (cargadorIndicePacientes === null) {
        //console.log('recargando pacientes f id: ' + getters.franquicia.id)
        //console.log("🚀 ~ file: pacientes.js ~ line 53", true)
        return new Promise(resolve => {
          cargadorIndicePacientes = db.collection(FS_COLLECTIONS.FRANQUICIAS)
            .doc(getters.franquicia.id)
            .collection(FS_COLLECTIONS.PACIENTES_INDICES).onSnapshot(docs => {

              const listaPacientes = {}
              docs.forEach(e => {

                const pacientes = e.data() || {}

                for (const i in pacientes) {
                  listaPacientes[i] = {
                    ...pacientes[i],
                    id: i,
                  }
                }

              })

              console.log("Pacientes idx", listaPacientes)


              commit('ASIGNA_INDICE_PACIENTES', listaPacientes)
              resolve(listaPacientes)
            })

        })

      }
    },


    cargaIndicePacientesV2({ commit, getters }, recarga = false) {

      if (getters.indicePacientes === null) {
        if (typeof cargadorIndicePacientesV2 === 'function') {
          cargaIndicePacientesV2()
        }
        cargadorIndicePacientesV2 = null
      }

      if (cargadorIndicePacientesV2 === null && cargadorIndicePacientes === null) {
        cargadorIndicePacientesV2 = db.collection(FS_COLLECTIONS.FRANQUICIAS)
          .doc(getters.franquicia.id)
          .collection(FS_COLLECTIONS.PACIENTES_INDICES).doc('Pacientes_0'); // Pacientes_0 debe ser el doc de pacientes editados recientemente
        cargadorIndicePacientesV2.get().then(doc => {
          const listaPacientes = {}
          const pacientes = doc.data() || {}

          for (const i in pacientes) {
            listaPacientes[i] = {
              ...pacientes[i],
              id: i,
            }
          }

          db.collection(FS_COLLECTIONS.FRANQUICIAS)
            .doc(getters.franquicia.id)
            .collection(FS_COLLECTIONS.PACIENTES_INDICES).doc('Pacientes_1') // Pacientes_0 debe ser el doc de pacientes editados recientemente
            .get().then(doc => {
              const pacientes2 = doc.data() || {}

              for (const i in pacientes2) {
                listaPacientes[i] = {
                  ...pacientes2[i],
                  id: i,
                }
              }

              return new Promise(resolve => {
                commit('ASIGNA_INDICE_PACIENTES_V2', listaPacientes)
                resolve(listaPacientes)
              });

            })


        });
      }
    },

    verificarTercerDoc({ dispatch, getters }, paciente) {
      return new Promise(async (resolve) => {
        const docRef = db.collection(FS_COLLECTIONS.FRANQUICIAS)
          .doc(getters.franquicia.id)
          .collection(FS_COLLECTIONS.PACIENTES_INDICES).doc('Pacientes_2');

        const doc = await docRef.get();
        if (doc.exists) {
          resolve(true)
        } else {
          resolve(false)
        }
      })
    },


    agregarPaciente({ dispatch, getters }, paciente) {
      var user = firebase.auth().currentUser
      // User Identifier
      paciente.usuario_padre = user.uid
      //console.log(getters.franquicia.id)

      //Cuando se importa se importa a la franquicia donde se esta logeado
      paciente.id_franquicia = getters.franquicia.id

      return new Promise((resolve, reject) => {

        if (paciente.id) {
          db.collection(FS_COLLECTIONS.PACIENTES).doc(paciente.id + '')
            .set(paciente)
            .then(docRef => {
              for (var k in paciente.propietarios) {
                let payload = {
                  propietario: paciente.propietarios[k],
                  paciente: paciente.id + ''
                }
                //console.log('agregarPaciente: ')
                dispatch('actualizaPropietarioPacienteInv', payload)
                //console.log('payload: ')
                //console.log(payload)
              }
              //dispatch('agregarIdPaciente', paciente.id+'')
              resolve(paciente.id + '')

            }).catch(error => {
              reject(error)
            })
        } else {
          paciente.fecha_creacion = new Date();
          db.collection(FS_COLLECTIONS.PACIENTES)
            .add(paciente)
            .then(docRef => {
              for (var k in paciente.propietarios) {
                let payload = {
                  propietario: paciente.propietarios[k],
                  paciente: docRef.id
                }
                //console.log('agregarPaciente: ')
                dispatch('actualizaPropietarioPacienteInv', payload)
                //console.log('payload: ')
                //console.log(payload)
              }
              //dispatch('agregarIdPaciente', docRef.id)
              resolve(docRef.id)

            }).catch(error => {
              reject(error)
            })
        }

      })

      //return db.collection(FS_COLLECTIONS.PACIENTES).add(paciente)
    },

    agregarIdPaciente({ }, pacienteID) {
      var paciente = {};
      paciente[`id`] = pacienteID;
      return db.collection(FS_COLLECTIONS.PACIENTES)
        .doc(pacienteID)
        .update(paciente)
    },
    eliminarPaciente({ }, pacienteID) {
      return db
        .collection(FS_COLLECTIONS.PACIENTES)
        .doc(pacienteID)
        .delete()
    },
    cargaPaciente({ commit }, idPaciente) {
      //console.log('1 store carga pac: ' + idPaciente)
      return new Promise((resolve, reject) => {
        let docPath = db.collection(FS_COLLECTIONS.PACIENTES).doc(idPaciente)
        /*docPath.get().then(doc => {
          //console.log('2 idPaciente Cargado: ', doc.data().id)
          commit('ASIGNA_PACIENTE', doc.data())
          resolve(doc.data())
        })*/
        docPath.onSnapshot(doc => {
          //console.log('2 idPaciente Cargado: ', doc.data().id)
          const paciente = doc.data();
          paciente.id = doc.id
          commit('ASIGNA_PACIENTE', paciente)
          resolve(paciente)
        })
      })
      //return cargadorPropietario
    },
    actualizarPaciente({ dispatch }, paciente) {
      // console.log('paciente.id: ' + paciente.id)
      return new Promise((resolve, reject) => {
        db.collection(FS_COLLECTIONS.PACIENTES)
          .doc(paciente.id)
          .update(paciente)
          .then(() => {
            for (var k in paciente.propietarios) {
              let payload = {
                propietario: paciente.propietarios[k],
                paciente: paciente.id
              }
              dispatch('actualizaPropietarioPacienteInv', payload)
            }
            resolve()
          }).catch(error => {
            reject(error)
          })
      })
    },
    actualizarPacienteServicioCaso({ }, props) {

      const { paciente, id_paciente } = props

      console.log("Actualizar paciente ", paciente)

      return new Promise((resolve, reject) => {

        db.collection(FS_COLLECTIONS.PACIENTES)
          .doc(id_paciente).set(paciente, { merge: true }).then(() => {
            resolve()
          }).catch(error => {
            reject(error)
          })

      })

    },
    // actualizamos la relación de pacientes en propietario
    actualizaPropietarioPacienteInv({ }, payload) {
      //console.log('paciente id: ')
      //console.log(payload.paciente)
      //console.log(payload.propietario)
      let docRef = db
        .collection(FS_COLLECTIONS.PROPIETARIOS)
        .doc(payload.propietario)
      db.runTransaction(transaction => {
        return transaction.get(docRef).then(doc => {
          if (!doc.exists) {
            throw 'Propietario no esiste!'
          }
          let propietario = doc.data()
          var pacientes = propietario.pacientes
          if (pacientes === undefined) {
            pacientes = []
          }

          if (!pacientes.includes(payload.paciente)) {
            pacientes.push(payload.paciente)
          }
          console.log(pacientes)
          transaction.update(docRef, { pacientes: pacientes })
        })
      })
    },
    removerPropietarioPacienteInv({ }, payload) {
      //console.log('paciente id: ')
      //console.log(payload.paciente)
      //console.log(payload.propietario)
      let docRef = db
        .collection(FS_COLLECTIONS.PROPIETARIOS)
        .doc(payload.propietario)
      db.runTransaction(transaction => {
        return transaction.get(docRef).then(doc => {
          if (!doc.exists) {
            throw 'Propietario no esiste!'
          }
          let propietario = doc.data()
          if (propietario.pacientes === undefined) {
            return
          }
          var pacientes = propietario.pacientes.filter(ele => {
            return ele != payload.paciente
          })
          transaction.update(docRef, { pacientes: pacientes })
        })
      })
    },
    cargaCatalogosPacientes({ commit, getters }) {
      //console.log(
      //'cargaCatalogosPacientes fraquicia id: ' + getters.franquicia.id
      //)
      return new Promise((resolve, reject) => {
        if (cargadorCatalogosPacientes === null) {
          let docPath = db
            .collection(FS_COLLECTIONS.FRANQUICIAS)
            // FIXME: Cargar desde  getters.franquicia.id cuando se haya implementado la copia de catalogos
            .doc(getters.franquicia.id)
            //.doc('tvolGQBvVqfhQFdTApm3')
            .collection(FS_COLLECTIONS.CATALOGOS)
            .doc(FS_COLLECTIONS.PACIENTES)
          cargadorCatalogosPacientes = docPath.onSnapshot(doc => {
            //console.log('Current data: ', doc.data())
            resolve()
            commit('ASIGNA_CATALOGOS', doc.data())
          })
        } else {
          resolve()
        }
      })
    },
    agregarPlanBienestarPaciente({ getters, dispatch }, data) {
      let docPath = db.collection(FS_COLLECTIONS.PACIENTES).doc(data.id_paciente)
      docPath.get().then(doc => {
        var nuevoPlan = doc.data();
        nuevoPlan.plan_bienestar = data.data;
        return new Promise((resolve, reject) => {
          db.collection(FS_COLLECTIONS.PACIENTES)
            .doc(data.id_paciente)
            .update(nuevoPlan)
            .then(() => {

              resolve();

              ////Se comento por que este flujo ya existia, marco hizo el otro flujo
              // dispatch('guardarCasoFantasma').then(url => {
              //   let plan = nuevoPlan.plan_bienestar.plan_actual;
              //   dispatch('guardarPlanBienestarComoServicio', { plan: plan, url: url }).then(() => {
              //     resolve();
              //   })
              // })
            })
        })
      })
    },
    renovarPlanBienestarPaciente({ getters, dispatch }, data) {

      let { planActual, planAnterior, idPlanAnterior, planesAnteriores, id_paciente, id_plan, fecha_inicio } = data;

      planAnterior.id = idPlanAnterior;
      planesAnteriores.push(planAnterior);

      let plan = {
        plan_bienestar: {
          id_plan: id_plan,
          plan_actual: {},
          planes_anteriores: [],
        }
      }

      plan.plan_bienestar.plan_actual = planActual;
      plan.plan_bienestar.plan_actual.fecha_inicio = fecha_inicio;
      plan.plan_bienestar.planes_anteriores = planesAnteriores;


      return new Promise((resolve, reject) => {
        db.collection(FS_COLLECTIONS.PACIENTES).doc(id_paciente)
          .set(plan, { merge: true }).then(() => {
            resolve()
          }).catch(error => {
            reject(error);
          })
      })

    },
    guardarCasoFantasma({ getters, dispatch }) {
      return new Promise((resolve, reject) => {
        let caso = {
          id_paciente: getters.pacienteActual.id,
          nombre: "Plan de bienestar",
          es_plan_bienestar: true,
          responsable: {
            email: getters.usuario.email,
            id: getters.usuario.id,
            nombre: getters.usuario.info.nombre + " " + getters.usuario.info.apellidos,
            rol: getters.usuario.rol,
          },
          sucursal: {
            id: getters.sucursalActual,
          }
        };
        dispatch('agregarCaso', caso).then(url => {
          dispatch('agregarCasoPropietario', url.id).then(() => {
            resolve(url);
          })
        }).catch(error => {
          reject(error)
        })
      })
    },
    guardarPlanBienestarComoServicio({ getters }, { plan, url }) {
      return new Promise((resolve, reject) => {
        console.log("SERVICIO DE PLAN DE BIENESTAR")
        console.log(servicio);
        console.log("Pacinte")
        console.log(getters.pacienteActual)
        console.log("Plan para guardar en saldo")
        console.log(plan);
        console.log("Url nuevo plan fantasma")
        console.log(url);
        var fecha_alta = new Date();
        var servicio = {
          //id_caso:'',
          tipo: 'Plan bienestar',
          anio: new Date().getFullYear(),
          id_paciente: getters.pacienteActual.id,
          id_propietario: getters.pacienteActual.propietarios[0],
          id_sucursal: getters.sucursalActual,
          servicio_padre: null,
          id_caso: url.id,
          ticket: null,
          no_ticket: 0,
          servicio_generico: {
            tiene_plan: false,
            monedero: { aplica: false, cantidad: 0 },
            descuento_personalizado: 0,
            descuento_personalizado_nombre: '',
            pesos_monedero: 0,
            completado: true,
            nombre: 'Plan de bienestar - ' + plan.nombre,
            precio: plan.precio,
            responsable: {
              email: getters.usuario.email,
              id: getters.usuario.id,
              nombre: getters.usuario.info.nombre + " " + getters.usuario.info.apellidos,
              rol: getters.usuario.rol,
            },
            servicio_padre: null,
            concepto: plan.nombre,
            concepto_vencimiento: '',
            hora: '',
            cantidad: 1,
            total: plan.precio,
            subtotal: plan.precio,
            monto: 0,
            servicio: {
              SKU: 'SKU',
              activo: true,
              id: '',
              nombre: plan.nombre,
              precioVenta: plan.precio,
              servicio_padre: null,
            },
            info: {
              fecha_alta: fecha_alta,
              fecha_vencimiento: fecha_alta,
            },
            descuento: {},
            activo: true
          },
        }
        db.collection(FS_COLLECTIONS.FRANQUICIAS)
          .doc(getters.franquicia.id).collection("ServiciosCasos")
          .add(servicio)
          .then(docRefServicio => {
            resolve(docRefServicio)
          })
          .catch(error => {
            reject(error)
          })
      })
    },

    subirArchivoPaciente({ getters }, archivo) {
      var uid = firebase.auth().currentUser.uid
      //RmM51tSQN5OvsP2Ggk0DbPAvKWM2
      //foto.jpg
      //RmM51tSQN5OvsP2Ggk0DbPAvKWM2/foto.jpg
      return new Promise((resolve, reject) => {
        storage
          .child(`Franquicias/${getters.franquicia.id}/Pacientes/${archivo.idPaciente}/${archivo.name}`)
          .put(archivo)
          .then(uploadTaskSnapshot => {
            uploadTaskSnapshot.ref
              .getDownloadURL()
              .then(url => {
                resolve(url)
              })
              .catch(error => reject(error))
          })
          .catch(error => reject(error))
      })
    }



  } //fin actions
}

export default store



// WEBPACK FOOTER //
// ./src/store/pacientes/pacientes.js